import { Link } from "react-router-dom";
import type { Drama } from "@/types/content";
import RatingStars from "./RatingStars";

export default function DramaCard({ drama, rank }: { drama: Drama; rank?: number }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/drama/${drama.id}`} className="block">
        <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-200">
          <img
            src={drama.cover}
            alt={`短剧《${drama.title}》官方海报`}
            title={`${drama.title} 演员表 导演编剧信息`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
          />
          {typeof rank === "number" && (
            <span className="absolute left-2.5 top-2.5 flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
              {rank}
            </span>
          )}
          <span className="absolute right-2.5 top-2.5 flex items-center gap-1 rounded-md bg-secondary-950/80 px-2 py-1 text-xs text-accent-400">
            <i className="ri-fire-line"></i>
            {(drama.heat / 10000).toFixed(1)}万
          </span>
        </div>
      </Link>

      <div className="flex flex-1 flex-col p-4">
        <Link to={`/drama/${drama.id}`}>
          <h3 className="font-heading text-base font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
            {drama.title}
          </h3>
        </Link>

        <div className="mt-2 flex items-center gap-2">
          <RatingStars rating={drama.rating} size="text-xs" />
          <span className="font-heading text-sm font-bold text-primary-600">
            {drama.rating.toFixed(1)}
          </span>
          <span className="text-xs text-foreground-500">
            {(drama.ratingCount / 1000).toFixed(1)}k 人评
          </span>
        </div>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {drama.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span>共 {drama.episodes} 集 · {drama.status}</span>
          <span>{drama.year}</span>
        </div>
      </div>
    </article>
  );
}